import * as Yup from 'yup';

const appointmentDetailsStorageSchema = Yup.object().required().shape({
    reasonId: Yup.number().required(),
    departmentId: Yup.number().required(),
    marketKey: Yup.string().required(),
});

export { appointmentDetailsStorageSchema };
